import { useState, useMemo, useEffect } from 'react';

/**
 * 필터링된 데이터의 현재 페이지 관리 및 페이징된 데이터를 반환하는 훅.
 */
export const useInquiryPagination = (filteredData = [], itemsPerPage = 5, dependencies = []) => {
    const [currentPage, setCurrentPage] = useState(1);

    // 필터나 정렬 기준 등이 변경되면 1페이지로 자동 리셋
    useEffect(() => {
        setCurrentPage(1);
    }, dependencies);

    const totalPages = useMemo(() => 
        Math.ceil(filteredData.length / itemsPerPage) || 1
    , [filteredData.length, itemsPerPage]);

    const paginatedData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return filteredData.slice(start, start + itemsPerPage);
    }, [filteredData, currentPage, itemsPerPage]);

    return {
        currentPage,
        setCurrentPage,
        totalPages,
        paginatedData
    };
};
